import React, { useState, Fragment } from 'react';
import {
    DropdownToggle,
    DropdownMenu,
    Dropdown,
    DropdownItem,
} from 'reactstrap';
import { MDTApp } from '../../../../../actions/bootAction.js';
import { IconSet } from '../../../../atoms/mdt-iconset/index.js';
import { connect } from 'react-redux';
import { sendEventTrackingData } from '../../../../../helpers/commonUtils.js';
import './toolbarProfile.css';


const ToolbarHelp = (props) => {
    const { getResourceAccess } = props;
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleHelpClick = (landingPage, pageLabel) => {
        trackEvent(pageLabel);
        props.redirectTo(landingPage);
    }

    const trackEvent = (pageLabel) => {
        const eventParamObj = {
            eventCategory: 'globalHeader',
            eventAction: 'profileMenu',
            eventLabel: pageLabel,
            processLabels: false,
            translatableFields: [
                'eventLabel',
            ]
        };
        sendEventTrackingData(eventParamObj);
    }

    const toggle = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const { classes, t } = props;

    const helpMenuItems = [
        {
            permission: true,
            translatableLabel: 'overview',
            clickInfo: 'HELP',
            dataTest: 'overview',
        },
        {
            permission: true,
            translatableLabel: 'faq',
            clickInfo: 'FAQ',
            dataTest: 'faq',
        },
        {
            permission: getResourceAccess('FindMyRep', 'Read') && getResourceAccess('FindMySalesRep', 'Feature'),
            translatableLabel: 'nav.findMyRep',
            clickInfo: 'FINDMYSALESREP',
            dataTest: 'findMyRep',
        },
        {
            permission: true,
            translatableLabel: 'nav.contactUs',
            clickInfo: 'CONTACTUS',
            dataTest: 'contactUs',
        },
        {
            permission: getResourceAccess('UserGuidesLink', 'Feature'),
            translatableLabel: 'userGuides',
            clickInfo: 'USERGUIDES',
            dataTest: 'userGuides',
        },
        {
            permission: true,
            translatableLabel: 'mdt.termsAndConditions',
            clickInfo: 'TERMSANDCONDITIONS',
            dataTest: 'termsAndConditions',
        },
        {
            permission: getResourceAccess('PrivacyPolicy', 'Feature'),
            translatableLabel: 'nav.privacyPolicy',
            clickInfo: 'PRIVACYPOLICY',
            dataTest: 'privacyPolicy',
        }
    ];

    return (
        <div className={classes} >
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret>
                    <span className="body2 p-active display-name">
                        <IconSet name="New-Help" className="help-icon" />
                    </span>
                </DropdownToggle>
                <DropdownMenu>
                    {
                        helpMenuItems.map((item, index) => {
                            if (item.permission) {
                                return (
                                    <Fragment key={index}>
                                        <DropdownItem
                                            onClick={ () => handleHelpClick(item.clickInfo, item.translatableLabel) }
                                            data-test={ item.dataTest }>
                                            <span
                                                className="menu-text body2 p-active"
                                                data-auid="header-view-profile-link">
                                                {t(item.translatableLabel)}
                                            </span>
                                        </DropdownItem>
                                        <DropdownItem divider />
                                    </Fragment>
                                )
                            }
                        }).filter(item => item !== undefined)
                    }
                </DropdownMenu>
            </Dropdown>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        customerName: !!state.meDetails.user ? state.meDetails.user.name : '',
        pageName: state.page,
        isInternalUser: state.meDetails.isInternal || 'false',
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        redirectTo: (page, data) => dispatch({ type: page, payload: { filter: data } }),
        sso: (redirectFlag, editProfileUrl) => dispatch(MDTApp.sso(redirectFlag, editProfileUrl)),
        getResourceAccess: (resource, action) => dispatch(MDTApp.getResourceAccess(resource, action)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarHelp);